import React from 'react';
import { useForm } from 'react-hook-form';
import { injectIntl } from '../../utils/reactIntl';
import {
  Button,
  FieldCheckbox,
} from '../../components';
import './exportpayment.global.scss';
import '../../components/LayoutWrapperMain/LayoutWrapperMain.global.scss';

interface Props {
  intl: any;
  handleFormSubmit: any,
  handleCloseModal: any,
}

enum ButtonTypes {
  'button',
  'submit',
  'reset',
  undefined
}

const ExportPaymentInfoForm: React.FC<Props> = (props: Props) => {
  const {
    intl,
    handleFormSubmit,
    handleCloseModal,
  } = props;
  const formProps = useForm();

  return (
    <form className="filterForm" onSubmit={formProps.handleSubmit(handleFormSubmit)}>
      <FieldCheckbox
        id="detail"
        name="detail"
        formProps={formProps}
        className="radioColumn"
        label="Payment Details"
      />
      <div className="buttonWrapper">
        <Button
          onClick={handleCloseModal}
        >
          {intl.formatMessage({ id: 'ExportUserInfo.button.cancel' })}
        </Button>
        <Button
          buttonType={ButtonTypes.submit}
        >
          {intl.formatMessage({ id: 'ExportUserInfo.button.export' })}
        </Button>
      </div>
    </form>
  );
};

export default injectIntl(ExportPaymentInfoForm);
